import Text from "@commons/Typography/Text";

type FieldProps = {
  label: string;
  value: string | number | React.ReactNode;
};

function Field({ label, value }: FieldProps) {
  return (
    <Text size="sm" className="font-roboto">
      <span className="font-semibold">{label}</span>:{" "}
      <Text
        component="span"
        size="sm"
        customVariant="gray"
        className="font-roboto"
      >
        {value}
      </Text>
    </Text>
  );
}

export default Field;
